export default "__VITE_ASSET__eOkK7gHs__"